import ViewSectionContent from './ViewSectionContent';

export default ViewSectionContent;
